import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BusinesscoItem, DepartmentItem, StockplaceItem } from '@app/services/logistic.service';
import { OrderHeadGet, OrderMethodItem, PortalUserItem, SellerItem } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-info-form',
    templateUrl: './order-head-info-form.component.html',
    styleUrls: ['./order-head-info-form.component.css'],
})
export class OrderHeadInfoFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public orderHeadProvider?: () => OrderHeadGet | undefined;

    @Output()
    public converted = new EventEmitter<void>();

    @Input()
    public form?: FormGroup;

    @Input()
    public companies: BusinesscoItem[] = [];

    @Input()
    public portalUsers: PortalUserItem[] = [];

    @Input()
    public orderMethods: OrderMethodItem[] = [];

    @Input()
    public stockplaces: StockplaceItem[] = [];

    @Input()
    public sellers: SellerItem[] = [];

    @Input()
    public departments: DepartmentItem[] = [];

    public isReadonly(setting: string): boolean {
        return setting === '2';
    }
}
